module.exports = __webpack_public_path__ + "static/Ã¶konmie1-81a3f09a5f66ee9d9e4ddeec1d73b9dc.png";